var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResourceGroupLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 62.6721L8.9043 49.3361L32.0003 36.0081L55.0883 49.3361L32.0003 62.6721Z",
    fill: "url(#paint0_linear_1499_390885)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0005 54.6801L8.89648 41.3441L8.90448 14.6641L32.0005 27.9921V54.6801Z",
    fill: "url(#paint1_linear_1499_390885)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.104 41.3439L32 54.6799V27.9919L55.096 14.6639L55.104 41.3439Z",
    fill: "url(#paint2_linear_1499_390885)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 27.9919L8.9043 14.6639L32.0003 1.32788L55.0963 14.6639L32.0003 27.9919Z",
    fill: "url(#paint3_linear_1499_390885)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7756 21.3361L43.7116 8.09605L43.3756 7.90405L20.4316 21.1521L20.7756 21.3361Z",
    fill: "#C6C6C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 28.1921L8.9043 14.8561V14.6641L9.0723 14.5681L32.1683 27.9041L32.0003 27.9921V28.1921Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1918 26.6639L10.6318 22.8799L10.6398 18.3279L17.1918 22.1199V26.6639Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1499_390885",
    x1: 14.6803,
    y1: 59.3361,
    x2: 49.3203,
    y2: 39.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1499_390885",
    x1: 12.1285,
    y1: 34.6721,
    x2: 32.2485,
    y2: 34.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1499_390885",
    x1: 32,
    y1: 34.6719,
    x2: 55.104,
    y2: 34.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1499_390885",
    x1: 14.6803,
    y1: 24.6639,
    x2: 49.3203,
    y2: 4.66388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResourceGroupLarge);
export default __webpack_public_path__ + "static/media/no-resource-group-large.776613943ea09b3248b6f4a8b15915ba.svg";
export { ForwardRef as ReactComponent };